import { render, staticRenderFns } from "./DocsEdit.vue?vue&type=template&id=649d1227&"
import script from "./DocsEdit.vue?vue&type=script&lang=js&"
export * from "./DocsEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports